// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".skill-custom-modal .ant-modal-content {\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.12);\n}\n.skill-custom-modal .ant-modal-header {\n  border-radius: 8px 8px 0 0 ;\n  border-bottom: 1px solid #f0f0f0;\n}\n.skill-custom-modal .ant-modal-footer {\n  border-radius: 0 0 8px 8px;\n  border-top: 1px solid #f0f0f0;\n  padding: 16px 24px;\n}\n", ""]);
// Exports
exports.locals = {
	"sideBarWidth": "210px",
	"appHeaderHeight": "60px",
	"interval": "16px"
};
module.exports = exports;
